import type { RenderProps } from 'hb-builder/components/common/type/RenderProps';
import PartnersSliderUI from 'hb-builder/components/UIComponents/page/block/Partners/PartnersSlider/SliderUI';
import type { PartnersSliderItem } from 'hb-builder/components/UIComponents/page/block/Partners/PartnersSlider/types';
import { useRendererContext } from 'hb-builder/hooks';
import type { RenderComponent } from 'hb-builder/types';

const PartnersSlider: RenderComponent = () => <div />; // never used

const Render = ({ item }: RenderProps<PartnersSliderItem>) => {
  const { subdomainNetworkUrl } = useRendererContext();

  return (
    <PartnersSliderUI item={item} subdomainNetworkUrl={subdomainNetworkUrl} />
  );
};

PartnersSlider.componentName = 'PartnersSlider';
PartnersSlider.Render = Render;

export default PartnersSlider;
